<template>
    <div class="bgcolor bgpadding">
        <!-- <el-row> -->
            <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="box-sizing: border-box;float: none;margin: 0 auto;"> -->
            <div class="warp_container">
                <div class="order_top white_bg margin_btm" v-if="account.order_status==='paid'||account.order_status==='complete'">
                    <div class="order_top_warp">
                        <div class="pay-jdL">
                            <div>提交订单</div>
                            <i></i>
                        </div>
                        <div class="pay-jd">
                            <span class="pay-num"></span>
                        </div>
                        <div class="pay-jdL pay-jdR">
                            <div>完成支付</div>
                            <i></i>
                        </div>
                    </div>
                </div>
                <!-- <div class="order_main white_bg"> -->
                    <div class="details">
                        <div class="line">订单详情</div>
                        <div class="details_conter">
                            <!-- <table class="order_list">
                                <tr>
                                    <td class="td_left">订单编号：</td><td>{{account.order_sn}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">订单状态：</td><td>{{account.order_status_text}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">订单名称：</td><td>{{account.order_title}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">订单金额：</td><td>{{account.order_amount}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">支付方式：</td><td>{{account.order_payment_type_text}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">支付时间：</td><td>{{account.order_pay_time_text}}</td>
                                </tr>
                            </table> -->
                            <div class="details_img_box"><img :src="account.goods_img" alt=""></div>
                            <div class="details_list">
                                <div><span>订单号：</span><span>{{account.order_sn}}</span></div>
                                <div><span>订单名称：</span><span>{{account.order_title}}</span></div>
                                <div><span>订单状态：</span><span>{{account.order_status_text}}</span></div>
                            </div>
                            <div class="details_list details_list_width">
                                <div><span>订单金额：</span><span>{{account.order_amount}}</span></div>
                                <div><span>支付方式：</span><span>{{account.order_payment_type_text}}</span></div>
                                <div><span>支付时间：</span><span>{{account.order_pay_time_text}}</span></div>
                            </div>
                        </div>
                    </div>
                    <!-- <template v-if="account.course_is_textbook==1"> -->
                    <!-- <div class="address_box" v-if="hasAddress===1">
                        <div class="address_title">
                            <div class="line">选择教材收货地址</div>
                            <div class="address_add" @click="addDialog"><img class="add_img" src="../assets/add.png" alt=""><span>新增收货地址</span></div>
                        </div>
                        <div class="address" v-if="address_list.length"> -->
                            <!-- <table class="order_list" v-if="account.order_address_tel !='' && account.order_address_name !='' && account.order_address !='' ">
                                <tr>
                                    <td class="td_left">收货人：</td><td>{{account.order_address_name}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">手机号：</td><td>{{account.order_address_tel}}</td>
                                </tr>
                                <tr>
                                    <td class="td_left">收货地址：</td><td>{{account.order_address}}</td>
                                </tr>
                            </table>
                            <template v-else>
                                <div class="opt_address" v-for="(val,key) in address_list" :key="key">
                                    <el-radio v-model="active_address" :label="val.ad_id">{{val.ad_name}},{{val.ad_tel}},{{val.ad_address}}</el-radio>
                                </div>
                                <div class="add_box" @click="dialogAddress=true"><img class="add_img" src="../assets/add.png" alt=""><span>新增收货地址</span></div>
                            </template> -->
                            <!-- <div v-for="(item,key) in address_list" :key="key" class="address_item">
                                <div class="address_item_box" :class="{active_address_bg:item.ad_id===active_address}" @click="checkeAddress(item.ad_id)">
                                    <div class="address_item_name" :class="{active_address_borderbtm:item.ad_id===active_address}">
                                        <span>{{item.ad_name}}</span>
                                        <span>{{item.ad_tel}}</span>
                                    </div>
                                    <div class="">
                                        <div class="address_item_details">{{item.ad_address}}{{item.ad_address_detail}}</div>
                                        <div v-if="item.ad_id===active_address" style="color: #FF6F02;cursor: pointer;" @click="editDialog(item)">修改</div>
                                    </div>
                                    <img class="address_right_img" v-if="item.ad_id===active_address" src="../assets/active.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- </template> -->
                    <template v-if="account.order_status==='paid'||account.order_status==='complete'">
                        <!-- <div class="submit_btn" v-if="hasAddress===1" @click="submit">提交</div> -->
                        <div class="submit_btn" @click="tocourse">返回</div>
                    </template>
                    <div class="submit_btn" v-else @click="topay">支付</div>
                <!-- </div> -->
            </div>
            <!-- </el-col> -->
        <!-- </el-row>    -->
        <el-dialog :visible.sync="show" class="aidlog_title_box" :show-close="show_close">
            <img src="../assets/hint.png" alt="">
            <p>请选择教材收货地址</p>
        </el-dialog>
        <el-dialog :title="diologTitle" width="500px" :visible.sync="dialogAddress">
            <table>
                <tr class="ad_tr">
                    <td class="left_td">所在地区</td><td class="right_td"><v-distpicker :province="province" :city="city" :area="area" @selected="sel"></v-distpicker></td>
                </tr>
                <tr class="ad_tr">
                    <td class="left_td">详细地址</td><td class="right_td"><input v-model="address" type="text" placeholder="请输入详细地址信息，如道路、门牌号等"></td>
                </tr>
                <tr class="ad_tr">
                    <td class="left_td">收货人姓名</td><td class="right_td"><input v-model="username" type="text" placeholder="请输入收货人姓名"></td>
                </tr>
                <tr class="ad_tr">
                    <td class="left_td">手机号码</td><td class="right_td"><input v-model="phone" type="number" placeholder="请输入收货人手机号"></td>
                </tr>
            </table>
            <div class="add_btn" @click="submit_add">保存</div>
        </el-dialog>
    </div>
</template>

<script>
    import VDistpicker from 'v-distpicker'
    import districts from "v-distpicker/src/districts"
    import store from '../store'
    export default {
        components: { VDistpicker },
        data() {
            return {
                account:'',
                address_list: [],
                active_address: '',
                show: false,
                show_close: false,
                dialogAddress: false,
                phone: '',
                username: '',
                address: '',
                region: '',
                area_code: '',
                province: "",
                city: "",
                area: "",
                hasAddress: '',
                isEdit: false
            }
        },
        created() {
            this.getData()
            // this.checkOrder()
            // this.get_address()
        },
        computed: {
            diologTitle() {
                return this.isEdit ? "编辑收货地址" : "新增收货地址";
            }
        },
        methods: {
            getData() {
                this.$http.get('/api/v2/course_order/getOrderInfo',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):''
                    },
                    params:{
                        order_sn: this.$route.query.order_sn
                        // order_sn: 2019110410255995
                    }
                })
                .then((res) => {
                    if(res.data.code===1){
                        this.account=res.data.data;
                        // if(res.data.data.order_address_tel===''){
                        //     this.get_address()
                        // }
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            addDialog() {
                this.isEdit = false;
                this.phone = "";
                this.area_code = "";
                this.username = "";
                this.address = "";
                this.province = "";
                this.city = "";
                this.area = "";
                this.dialogAddress = true;

            },
            editDialog(data) {
                this.isEdit = true;
                this.getEditArea(data.ad_area_code)
                this.phone = data.ad_tel;
                this.username = data.ad_name;
                this.address = data.ad_address_detail;
                this.area_code = data.ad_area_code;
                this.active_address = data.ad_id;
                this.dialogAddress = true;
            },
            checkOrder() { //检测订单是否支付
                this.$http.get('/api/v2/course_order/checkOrder',{
                    headers:{ 'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'' },
                    params:{
                        order_sn: this.$route.query.order_sn
                    }
                }).then((res) => {
                    if(res.data.code===1){
                        this.hasAddress=res.data.data.write_address
                        // if(res.data.data.order_status==='paid') {
                        //     if(res.data.data.write_address===1){
                        //         this.$router.push({path:'/accountPaid',query:{out_trade_no: this.orderData.order_sn}});
                        //     }else if(res.data.data.write_address===0){
                        //         this.$message({
                        //             message: '支付完成',
                        //             type: 'success'
                        //         });
                        //         var that=this;
                        //         window.setTimeout(function(){
                        //             that.$router.push({name:'courseDescription', params: {course_id:that.$route.query.course_id}})
                        //         },800);
                        //     }
                        // }else{
                        //     this.$message.error("您的订单尚未支付")
                        // }
                   }else if(res.data.code===0){
                       this.$message.error(res.data.msg)
                   }
                }).catch((err) => {
                    // console.log(err);
                })
            },
            sel(data) {
                this.area_code=data.area.code
                this.region = data.province.value + data.city.value + data.area.value;
            },
            get_address() {
                this.$http.get('/api/v2/Address/getAddress',{ //获取用户地址
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                }).then((res) => {
                    
                    if(res.data.code===1){
                        this.address_list=res.data.data;
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){ //登录检测
                        store.commit('setDialogLogin',true);
                    }
                })
            },
            topay() { //去付款
                this.$router.push({path: '/pay',query: {order_sn:this.account.order_sn}})
            },
            tocourse(){ //返回详情页面
                this.$router.push({name:'courseDescription', params: {course_id:this.account.order_target_id}})
            },
            checkeAddress(id) { //选中地址id
                this.active_address=id;
            },
            submit() {
                var ad_id= this.active_address;
                if(ad_id == undefined || ad_id == '' || ad_id == null){
                    this.show=true;
                    return false;
                }
                this.$http.post('/api/v2/Course_order/addOrderAddress',
                {
                    order_sn: this.account.order_sn,
                    address_id: ad_id
                },
                {
                    headers:
                        {
                            'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                        }
                })
                .then((res) => {
                    if(res.data.code===1){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                        var that=this;
                        window.setTimeout(function(){
                            that.$router.push({name:'courseDescription', params: {course_id:that.account.order_target_id}})
                        },800);
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
            },
            submit_add() {
                if(!(/^1[0123456789]\d{9}$/.test(this.phone))){ //验证手机号
                    this.$message.error('手机号码格式有误')
                    return false
                }
                if(this.username.match(/^\s*$/)){
                    this.$message.error('用户名不能为空或全空格')
                    return false
                }
                if(this.region.match(/^\s*$/)){
                    this.$message.error('地区不能为空')
                    return false
                }
                if( this.address.match(/^\s*$/)){
                    this.$message.error('详细地址不能为空')
                    return false
                }
                
                this.isEdit ? this.edit() : this.add()
            },
            add() {
                this.$http.post('/api/v2/Address/add',
                {
                    ad_name: this.username,
                    ad_tel: this.phone,
                    ad_address: this.region,
                    ad_address_detail: this.address,
                    ad_area_code: this.area_code
                },
                {
                    headers:
                        {
                            'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                        }
                })
                .then((res) => {
                    if(res.data.code===1){
                        this.get_address()
                        this.dialogAddress = false;
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg)
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
            },
            edit() {
                this.$http.post("/api/v2/Address/edit",
                {
                    ad_id: this.active_address,
                    ad_name: this.username,
                    ad_tel: this.phone,
                    ad_address: this.region,
                    ad_address_detail: this.address,
                    ad_area_code: this.area_code
                },
                {
                    headers:
                        {
                            'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                        }
                })
                .then((res) => {
                    if(res.data.code===1){
                        this.$message({
                            message: res.data.msg,
                            type: "success"
                        });
                        this.get_address()
                        this.dialogAddress = false;
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg)
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch((err) => {
                    this.$message.error(err);
                })
            },
            getEditArea(val) {
                let province_code = val.substr(0, 2) + "0000",
                    city_code = val.substr(0, 4) + "00",
                    area_code = val;

                for (let i in districts["100000"]) {
                    if (i === province_code) {
                    this.province = districts["100000"][i];
                    }
                }

                for (let i in districts[province_code]) {
                    if (i === city_code) {
                    this.city = districts[province_code][i];
                    }
                }

                for (let i in districts[city_code]) {
                    if (i === area_code) {
                    this.area = districts[city_code][i];
                    }
                }
                this.region = this.province + this.city + this.area;
            },
        }
    }
</script>

<style scoped>
    .order_top_warp{
        width: 520px;
        margin: 0 auto;
        height: 160px;
        padding: 20px 0;
        overflow: hidden;
        position: relative;
    }
    .pay-jdL {
        width: 100px;
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
    }
    .pay-jdL i {
        background: url('../assets/dingdan3.png') no-repeat 0 0;
        background-size: cover;
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .pay-jdR i {
        background: url('../assets/dingdan4.png') no-repeat 0 0;
        background-size: cover;
    }
    /* .pay-jdL p {
        color: #47c88a;
        font-size: 16px;
    } */
    .pay-jdL div {
        color: #00C590;
        font-size: 18px;
        padding-bottom: 10px;
    }
    .pay-jdR {
        right: 0;
    }
    .pay-jd {
        width: 390px;
        height: 4px;
        background: #8AD23D;
        float: left;
        position: absolute;
        top: 54%;
        left: 64px;
    }
    
    .pay-jd .pay-num {
        display: block;
        height: 4px;
        background:  #00C590;
        width: 50%;
    }
    .margin_btm{
        margin-bottom: 20px;
    }
    .order_main{
        padding: 30px 0;
        /* margin-bottom: 50px; */
    }
    .details,.address_box{
        /* width: 550px; */
        background: #ffffff;
        width: 100%;
        padding: 30px 30px 0;
        box-sizing: border-box;
        /* border: 2px solid #CCCCCC; */
        /* border-radius: 15px; */
        /* margin: 0 auto; */
        font-size: 16px;
    }
    .details{
        padding-bottom: 40px;
        /* height: 255px; */
        /* text-align: center; */
    }
    .address_box{
        padding-bottom: 30px;
    }
    .line{
        border-left: 5px solid #00c590;
        padding-left: 10px;
        color: #333333;
        font-size: 18px;
        margin-bottom: 20px;
    }
    .details h4,.address_box h4{
        text-align: center;
        margin: 0;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
    }
    .details_conter{
        display: flex;
        border:1px solid rgba(204,204,204,1);
        /* padding: 20px 0 20px 40px; */
        border-radius:10px;
        width: 100%;
        height: 142px;
    }
    .details_img_box{
        width: 26%;
    }
    .details_img_box img{
        width: 200px;
        height: 100px;
        margin: 21px;
        border-radius: 10px;
    }
    .details_list{
        width: 40%;
        display: flex;
        flex-direction: column;
        padding: 23px 0;
        justify-content: space-between;
    }
    .details_list_width{
        width: 34%;
    }
    /* .details_conter>div{
        width: 100%;
    } */
    /* 表格布局 */

    .td_left{
        min-width: 90px;
    }
    td{
        padding-bottom: 8px;
    }
    .order_list{
        font-size: 16px;
        color: #333333;
    }
    /* 表格end */
    .dc_left{
        width: 110px;
        float: left;
    }
    .dc_right{
        float: left;
    }
    /* 地址盒子 */
    .address_box{
        margin-top: 20px;
    }
    .address_title{
        display: flex;
    }
    .address_add{
        margin-left: 40px;
        cursor: pointer;
    }
    .address{
        /* border-top: 2px solid #CCCCCC;
        padding: 20px 40px 20px 40px;
        box-sizing: border-box; */
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .address_item{
        width: 25%;
        height: 126px;
        margin-bottom: 14px;
    }
    .address_item_box{
        width: 276px;
        height: 100%;
        font-size: 14px;
        background: url("../assets/address_bg2.png") no-repeat 0 0;
        background-size: cover;
        padding: 0 17px;
        box-sizing: border-box;
        position: relative;

    }
    .active_address_bg{
        background: url("../assets/address_bg.png") no-repeat 0 0 !important;
        background-size: cover !important;
    }
    .address_right_img{
       width: 20px;
       height: 20px; 
       position: absolute;
       right: 5px;
       bottom: 7px;
    }
    .address_item_name{
        height: 45px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .active_address_borderbtm{
        border-bottom: 1px solid #00c590 !important;
    }
    .address_item_details{
        margin: 10px 0;
    }
    .opt_address{
        box-sizing: border-box;
        word-break:break-all
    }
    /* .address div{
        margin-bottom: 15px;
    } */
    /* .address span{
        display: inline-block;
        width: 90px;
    } */
    .address input{
        border: 0;
        outline: none;
        border-bottom: 1px solid #999999;
    }
    input::placeholder{
        color: #999999;
        font-size: 14px;
    }
    .submit_btn{
        width:120px;
        height:40px;
        background: linear-gradient(30deg,rgba(255,142,2,1),rgba(255,111,2,1));;
        border-radius:20px;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        margin: 25px auto 0px;
        cursor: pointer;
    }
    /* 数字输入框去掉上下选择 */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none; 
        margin: 0; 
    }
    input{
        -moz-appearance: textfield;
    }
    /* 新增地址 */
    .add_img{
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    .add_box{
        width: 100%;
        text-align: center;
        vertical-align: middle;
    }
    .ad_tr{
        margin-bottom: 30px;
    }
    d{
        padding-bottom: 30px;
    }
    td input{
        border-radius:8px;
        border:1px solid #cccccc;
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
    }
    .right_td{
        padding-left: 20px;
        box-sizing: border-box;
    }
    .left_td{
        /* float: right; */
        text-align: right;
        padding-left: 40px;
    }
    .add_btn{
        width:120px;
        height:40px;
        background:#FF6029;
        border-radius:20px;
        font-size: 20px;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        margin: 0 auto;
    }
</style>
<style>
    .opt_address .el-radio{
        box-sizing: border-box;
    }
    .opt_address .el-radio__label{
        display: inline-grid;
        white-space: pre-line;
        word-wrap: break-word;
        overflow: hidden;
        box-sizing: border-box;
    }
    /* 提示盒子 */
    .aidlog_title_box .el-dialog{
        width:280px;
        height:180px;
        border-radius:20px;
        text-align: center;
    }
    .aidlog_title_box img{
        width: 60px;
        height: 60px;
    }
    .aidlog_title_box .el-dialog__body{
        color: #333333;
        font-size: 20px;
        padding-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/page/AccountPaid.vue